import React, { useEffect, useState } from 'react'
import SideNav from 'components/sidenav/Sidenav'
import {
  Wrapper,
  Header,
  Body,
  Footer,
  SideContainer,
  SidePanel,
  Container,
  HeaderName,
  MarginTop
} from './styles'
import Table from '1.newComponents/Table'
import getCRF from 'API/functions/getCRF'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearTable,
  selectTableSlice,
  setTable
} from '1.newComponents/Table/tableSlice'
import {
  STATUS,
  CRF_NO,
  CREATION_DATE,
  EXPECTED_COMPLETION_DATE,
  DUE_DATE,
  TOTAL_NET_PRICE,
  DEPARTMENT,
  PROJECT,
  VENDOR
} from 'types'
import { Button } from '@material-ui/core'
import downloadAsCSV from '1.newComponents/containers/downloadAsCSV'
import cashAdvancesConfig from '0.componentConfigs/3.liquidation'
import CheckRequestView from '1.newComponents/checkRequestView'
import { Redirect } from 'react-router-dom'

function AllRequest (props) {
  const tableSlice = useSelector(selectTableSlice)
  const [selectedId, setSelectedId] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState({ page: 0, pageSize: 50 })
  const [isDownloadAll, setIsDownloadAll] = useState(false)
  const [crfToBeDownloaded, setCrfToBeDownloaded] = useState([])
  const headers = [
    CRF_NO,
    CREATION_DATE,
    EXPECTED_COMPLETION_DATE,
    DUE_DATE,
    VENDOR,
    TOTAL_NET_PRICE,
    DEPARTMENT,
    PROJECT,
    STATUS
  ]
  const dispatch = useDispatch()
  useEffect(() => {
    loadCRF()
    return () => {
      dispatch(clearTable())
    }
  }, [])

  const loadCRF = async () => {
    setIsLoading(true)
    const result = await getCRF()
    if (result.status === 200) {
      dispatch(setTable({ headers, dataList: sortList(result.response) }))
      setIsLoading(false)
    }
  }

  const sortList = allRequests => {
    const finalArray = []
    allRequests.sort((a, b) => {
      return b.crfNo - a.crfNo
    })
    allRequests.filter((element, index) => {
      if (index === 0 || element.number !== allRequests[index - 1].number) {
        finalArray.push(element)
      } else {
        finalArray.push(element)
      }
    })
    return finalArray
  }

  return selectedId ? (
    <Redirect
      to={{
        pathname: `/CheckRequest/${selectedId}`,
        state: {
          from: props.location
        }
      }}
    />
  ) : (
    <>
      <SideContainer>
        <SidePanel>
          <SideNav />
        </SidePanel>
      </SideContainer>
      <Wrapper>
        <Header>
          <HeaderName>AllRequest</HeaderName>
          {tableSlice.dataList.length > 0 && (
            <Button
              variant='contained'
              onClick={() => {
                downloadAsCSV(tableSlice.dataList, page, isDownloadAll)
              }}
            >
              Download as CSV
            </Button>
          )}
          {tableSlice.dataList.length > 0 && (
            <select
              value={isDownloadAll}
              onChange={() => setIsDownloadAll(!isDownloadAll)}
            >
              <option value={false}>This page</option>
              <option value>All</option>
            </select>
          )}
        </Header>
        <Body>
          <MarginTop />
          <Container>
            <Table
              onRowClick={e => {
                setSelectedId(e.row.id)
              }}
              onSelectionModelChange={e =>
                setCrfToBeDownloaded(e.selectionModel)}
              loading={isLoading}
              setPage={data => {
                setPage({ page: data?.page, pageSize: data?.pageSize })
              }}
            />
          </Container>
        </Body>
        <Footer />
      </Wrapper>
    </>
  )
}

export default AllRequest
